export const PRONO_BASE_PATH = 'api/v2/prono';

/**
 * - `random`  : draw winners at random
 * - `all_win` : everyone tied wins (ignores `winnersCount`)
 * - `first`   : earliest participations win
 */
export const TIEBREAKER = {
  RANDOM: 'random',
  ALL_WIN: 'all_win',
  FIRST: 'first',
} as const;

export type Tiebreaker = (typeof TIEBREAKER)[keyof typeof TIEBREAKER];
export const DEFAULT_TIEBREAKER: Tiebreaker = TIEBREAKER.RANDOM;
export const SHOW_REALTIME = {
  NONE: 'none',
} as const;

export type ShowRealtime = (typeof SHOW_REALTIME)[keyof typeof SHOW_REALTIME];
export const DEFAULT_SHOW_REALTIME: ShowRealtime = SHOW_REALTIME.NONE;
export const PARTICIPANT_IDENTIFICATION = {
  PHONE_NAME: 'phone_name',
} as const;

export type ParticipantIdentification = (typeof PARTICIPANT_IDENTIFICATION)[keyof typeof PARTICIPANT_IDENTIFICATION];
export const DEFAULT_PARTICIPANT_IDENTIFICATION: ParticipantIdentification = PARTICIPANT_IDENTIFICATION.PHONE_NAME;

export const WINNERS_COUNT = {
  DEFAULT: 1,
  MIN: 1,
  MAX: 10,
} as const;

export const DEFAULT_PARTICIPANTS_PAGE_SIZE = 20;

export const HISTORY_ROWS_PER_PAGE: number[] = [5, 10];

export const PARTICIPANTS_ROWS_PER_PAGE: number[] = [10, 20];

export const POSTER_PRINT_CLEANUP_DELAY_MS = 120_000;

export const QR_CODE_SIZE = 192;
export const PRINT_QR_SIZE = 512;
